module.exports = __webpack_public_path__ + "img/prev-button.bcc75ef6.svg";